import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { auth, firestore as db } from "../../../../../backend/firebaseconfig";

export const logAuditChanges = async ({
  entity,
  entityId,
  changes = [],
  extra = {},
}) => {
  if (!entity || !entityId || !Array.isArray(changes) || !changes.length) {
    return;
  }

  const user = auth.currentUser;
  //   console.log("Logging audit changes:", {
  //     entity,
  //     entityId,
  //     changes,
  //     changedBy: user ? user.displayName || user.email : "unknown",
  //     changedByUid: user ? user.uid : "unknown",
  //     ...extra,
  //   });

  await Promise.all(
    changes.map((change) =>
      addDoc(collection(db, "AuditLogs"), {
        entity,
        entityId,
        section: change.section || "",
        field: change.field,
        oldValue: change.oldValue ?? null,
        newValue: change.newValue ?? null,
        changedBy:
          auth.currentUser?.displayName || auth.currentUser?.email || "unknown",
        changedByUid: auth.currentUser?.uid || "",
        changedAt: serverTimestamp(),
        ...extra,
      }),
    ),
  );
};
